<template>
    <div class="page diagnose-detail">

        <diagnose-detail-skeleton v-if="loading" style="margin-bottom: 100vh"></diagnose-detail-skeleton>

        <div v-else>
            <div class="diagnose-detail-box">
                <h3 class="diagnose-detail-title">{{detail.title}}</h3>
                <div style="padding: 0 15px 15px">
                    <div class="diagnose-detail-time">{{detail.created_at}} 阅读 {{detail.view_count}}</div>
                </div>
                <div class="clear" style="margin-top: 15px"></div>

                <div>
                    <div class="diagnose-detail-content">
                        <div class="rich_media_inner" v-html="detail.content"></div>
                    </div>
                </div>
            </div>

            <div class="diagnose-detail-footer">
                <div class="diagnose-detail-footer-box">
                    <div class="diagnose-detail-footer-left">
                        <van-grid :column-num="3" :border="false">
                            <van-grid-item @click="favorite()" v-if="detail.isFavorite" icon="/static/img/course/icon_course_favorite_on_20.svg" text="已收藏"/>
                            <van-grid-item @click="favorite()" v-else icon="/static/img/course/icon_course_favorite_off_20.svg" text="收藏"/>
                            <van-grid-item @click="pointLike()" v-if="detail.isLike" icon="/static/img/course/icon_course_like_on.svg" text="有帮助" :badge="detail.like_count"/>
                            <van-grid-item @click="pointLike()" v-else icon="/static/img/course/icon_course_like_off.svg" text="有帮助" :badge="detail.like_count"/>
                            <van-grid-item @click="openShareData" icon="/static/img/course/icon_course_share_20.svg" text="转发"/>
                        </van-grid>
                    </div>
                    <div class="diagnose-detail-footer-right">
                        <van-button class="diagnose-detail-footer-right-btn" type="danger" round size="large" @click="applyFormDialog = true" color="#0FB7AD">
                            我要申请
                        </van-button>
                    </div>
                </div>
                <van-number-keyboard safe-area-inset-bottom/>
            </div>

            <van-dialog class="apply_form" v-model="applyFormDialog" :showConfirmButton="false">
                <template slot="title">
                    <div class="close-pop" @click="closeApplyForm">
                        <img src="/static/bytx/popup_close_icon.svg" alt="">
                    </div>
                    <h3>申请诊断送检</h3>
                </template>
                <div class="clear"></div>
                <div>战友您好，申请检查检验项目，请点击下方按钮填写申请表单。</div>
                <div align="center" style="margin-top: 12px;color: #9D9D9D">
                    <van-button class="diagnose-detail-footer-right-btn" type="danger" round size="large" @click="goLogin()" color="#0FB7AD">
                        立即填写
                    </van-button>
                </div>
            </van-dialog>

            <van-overlay :show="showShareDialog" @click="showShareDialog = false">
                <div class="share-box">
                    <div class="block">
                        请点击 “...”，再点击发送给朋友 | <span>知道啦</span>
                    </div>
                </div>
            </van-overlay>
        </div>
    </div>

</template>

<script>
    import Interface from "@/util/interface"
    import diagnoseDetailSkeleton from "@/skeleton/articleDetailSkeleton"
    import checkLogin from "../../../mixins/checkLogin";

    export default {
        name: 'diagnose-detail',
        mixins: [checkLogin],
        components: {
            'diagnose-detail-skeleton': diagnoseDetailSkeleton
        },
        data() {
            return {
                id: 0,
                value: "",
                active: "",
                category_id: 0,
                category_child_id: 0,
                banners: [],
                categories: [],
                categories_child: [],
                recommend: [],
                list: [],
                column: [],
                diagnose: {},
                comment: [],
                comment_text: "",
                loading: true,
                share_data: {},
                showShareDialog: false,
                htmlUrl: "",
                isShow: false,
                status: "",
                comment_id: 0,
                to_user_id: 0,
                comment_placeholder: "写评论",
                user_id: 0,
                detail:{},
                applyFormDialog:false,
            }
        },
        methods: {
            fetch(scene) {
                if (scene === 'detail') {
                    Interface.getData('get', Interface.diagnose.detail + this.id).then((res) => {
                        this.detail = res.data
                        setTimeout(() => {
                            this.loading = false;
                        }, 500)
                        if (this.detail) {
                            Interface.getShareInfo(this, this.detail.title, this.detail.cover_img, this.detail.desc)
                        }
                    })
                } else if (scene === 'footprint') {
                    let params = {
                        id: this.id,
                        type: 11,
                    }
                    Interface.getData('post', Interface.footprint, params).then((res) => {

                    })
                } else if (scene === 'share') {
                    let params = {
                        content_id: this.id,
                        type: 2,
                    }
                    Interface.getData('get', Interface.share, params).then((res) => {
                        this.htmlUrl = res.data.post_img_url
                    })
                }
            },
            changeCategory() {
                this.fetch('diagnose')
            },
            favorite() {
                Interface.getData('get', Interface.diagnose.favorite + this.id).then((res) => {
                    if (res.code == 0) {
                        this.detail.isFavorite = !this.detail.isFavorite
                    }
                })
            },
            pointLike() {
                Interface.getData('get', Interface.diagnose.like + this.id).then((res) => {
                    if (res.code == 0) {
                        this.detail.like_count = this.detail.isLike ? parseInt(this.detail.like_count) - 1 : parseInt(this.detail.like_count) + 1
                        this.detail.isLike = !this.detail.isLike
                    }
                })
            },
            reComment(item) {
                this.comment_placeholder = '回复' + item.nickname
                this.comment_id = item.id
            },
            reCommentChild(item) {
                this.comment_placeholder = '回复' + item.nickname
                this.comment_id = item.comment_id
                this.to_user_id = item.user_id
            },
            pointLikeComment(item) {
                Interface.getData('get', Interface.pointLikeComment + item.id).then((res) => {
                    if (res.code == 0) {
                        item.isLike = !item.isLike
                        if (item.isLike) {
                            item.like_count += 1
                        } else {
                            item.like_count -= 1
                        }
                    }
                })

            },
            goComment() {
                this.$el.querySelector(".comment").scrollIntoView()
            },
            openShareData() {
                this.showShareDialog = true
            },

            goLogin(){
                //申请
                let user = localStorage.getItem("user");
                user = JSON.parse(user)
                sessionStorage.setItem("back-url", this.$route.path)
                sessionStorage.setItem("apply",JSON.stringify({
                    apply:'clinic',apply_id:this.id
                }))
                this.goAddInfo(user)
            },

            closeApplyForm(){
                this.applyFormDialog = false
            }

        },
        created() {
            this.id = this.$route.params.id
            this.fetch('detail')
            this.fetch('footprint')
            this.fetch('share')
        },
    }
</script>

<style lang="scss">
    @import "./index";
    @import "../../../components/comment";
</style>



// WEBPACK FOOTER //
// src/views/diagnose/detail/index.vue